<template>
  <div v-if="metadata.amazonMetadata.trialLimitReached">
    <div class="card shadow-sm">
      <div class="bg-light bg-gradient bd-placeholder-img card-img-top p-4">
        <svg
          class="rounded mx-auto d-block"
          width="100%"
          height="150px"
          xmlns="http://www.w3.org/2000/svg"
          role="img"
          aria-label="Placeholder: Thumbnail"
          preserveAspectRatio="xMidYMid slice"
          focusable="false"
        >
          <title>Placeholder</title>
          <rect width="100%" height="100%" fill="#dce0dd" />
          <text x="50%" y="50%" fill="#000000" dy=".3em">Upgrade to View</text>
        </svg>
      </div>

      <div class="card-body">
          <h6 class="card-title">
            <i :class="productStateIconClasses(metadata.amazonMetadata)" class="pe-1"></i>Unavailable - Upgrade to view
          </h6>
        <h4>
          <span v-if="metadata.amazonMetadata.productPrice">{{ metadata.amazonMetadata.productPrice }}</span>
          <span v-else>$N/A</span>
        </h4>
        <span class="badge bg-secondary me-1"><i class="bi-star-fill me-1"></i>?</span>
        <span class="badge bg-secondary">? reviews</span>
        <p class="card-text">
          <small>
            <a target="_blank"
                :href="metadata.amazonMetadata.productPage"
                :title="metadata.amazonMetadata.productTitle">[Open Amazon]</a><br/>
            <span>
              <i class="bi-exclamation-triangle-fill me-1"></i>Tag not checked<br/>
            </span>
            <span v-if="metadata.amazonLinkText"><strong>Your link text:</strong> "{{ metadata.amazonLinkText }}"<br></span>
            <span v-if="metadata.uniqueRedirectSet.length > 0"><strong>Short links:</strong><br>
            <a
              target="_blank"
              v-for="redirect in metadata.uniqueRedirectSet"
              :href="redirect"
              :key="redirect"
              >{{ redirect }},
            </a>
            </span>
          </small>
        </p>
      </div>
    </div>
  </div>
  <div v-else-if="! metadata.amazonMetadata.complete">
    <div class="card shadow-sm">
      <div class="bg-light bg-gradient bd-placeholder-img card-img-top p-4">
        <img
          class="rounded mx-auto d-block"
          style="max-width: 100%; max-height: 200px"
          src="/loading.gif"
          alt="'Loading product...'"
        />
      </div>
      <div class="card-body">
        <h6 class="card-title">Loading...</h6>
        <p class="card-text">Loading product details...</p>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="card shadow-sm">
      <div class="bg-light bg-gradient bd-placeholder-img card-img-top p-4">
        <img
          class="rounded mx-auto d-block"
          style="max-width: 100%; max-height: 200px"
          :src="metadata.amazonMetadata.productImage"
          :alt="'Image of ' + metadata.amazonMetadata.productTitle"
        />
      </div>

      <div class="card-body">
          <h6 class="card-title">
            <a href="#" @click.prevent="showProductPages(metadata)"
            :title="metadata.amazonMetadata.productTitle">
              <i :class="productStateIconClasses(metadata.amazonMetadata)" class="pe-1"></i>
              {{ shortTitle(metadata.amazonMetadata.productTitle) }}
            </a>
          </h6>
        
        <h4>
          <span v-if="metadata.amazonMetadata.productPrice">{{ metadata.amazonMetadata.productPrice }}</span>
          <span v-else>$N/A</span>
        </h4>
        <p>
          <span class="badge bg-secondary me-1"><i class="bi-star-fill me-1"></i>{{ metadata.amazonMetadata.productStars }}</span>
          <span class="badge bg-secondary">{{ metadata.amazonMetadata.productReviewCount }} reviews</span>
          <span :class="availabilityClasses(metadata.amazonMetadata.productAvailability)">{{ metadata.amazonMetadata.productAvailability }}</span>
        </p>
        <p class="card-text">
          <small>
            <a target="_blank"
                :href="metadata.amazonMetadata.productPage"
                :title="metadata.amazonMetadata.productTitle">[Open Amazon]</a><br/>

            <span v-if="metadata.amazonMetadata.affiliateTag">
              <i class="bi-tag-fill me-1"></i>{{ metadata.amazonMetadata.affiliateTag }}<br/>
            </span>
            <span v-else>
              <i class="bi-exclamation-triangle-fill me-1"></i>No tag found<br/>
            </span>

            <span v-if="metadata.amazonLinkText"><strong>Your link text:</strong> "{{ metadata.amazonLinkText }}"<br></span>
            <span v-if="metadata.uniqueRedirectSet.length > 0"><strong>Short links:</strong><br>
            <a
              target="_blank"
              v-for="redirect in metadata.uniqueRedirectSet"
              :href="redirect"
              :key="redirect"
              >{{ redirect }},
            </a>
            </span>
          </small>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["metadata", "product-id", "my-key"],
  data() {
    return {
      debugAccordion: false,
    };
  },
  methods: {
    availabilityClasses(availability) {
      if (! availability) {
        return {
          badge: true,
          'bg-success': true,
        }
      }

      let inStock = availability.includes('In Stock.');
      const orderSoon = availability.includes('left in stock - order soon');
      const unavailable = availability.includes('Currently unavailable.');

      if (! orderSoon && ! inStock && ! unavailable) {
        inStock = true; // Parse issue
      }

      return {
        badge: true,
        'bg-success': inStock,
        'bg-warning': orderSoon,
        'text-dark': orderSoon,
        'bg-danger': unavailable,
      }
    },
    showProductPages(amazonItem) {
      this.$router.push({
        name: 'pageResults',
        params: {
          productFilter: JSON.stringify(amazonItem) // Router params only work with strings?
        }
      })
    },
    productStateIconClasses(amazonMetadata) {
      let available = amazonMetadata.productAvailable == true;

      return {
        "bi-cart-check-fill": available,
        "bi-cart-x": !available,
      };
    },
    shortTitle(productTitle) {
      if (! productTitle) {
        return productTitle;
      }
      let maxLength = 80;
      return productTitle.length < maxLength
        ? productTitle
        : productTitle.substring(0, maxLength) + "...";
    },
  },
  mounted() {
    //console.log("my-key: " + this.myKey);//, this.myKey.amazonMetadata.productPage);
  },
};
</script>


